import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Represents the filterCryptoView class, extending JetView.
 */
export default class filterCryptoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'currencyId', // Cryptocurrency selection field
                            minWidth: 200,
                            label: "<span class='icon-shop'></span>" + _('Criptomoneda'), // Label for the combo box
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        // Data fetching for cryptocurrency options
                                        var vthis = this;
                                        if (text.length > 2) {
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/GetCryptoSummary',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message('Error! '); // Error handling
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (!resp.HasError) {
                                                                vthis.parse(resp.Data); // Parsing response data
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'richselect',
                            name: 'behavior',
                            label: "<span class='icon-state'></span>" + _('Tipo de Criptomoneda'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all
                                { id: '1', value: _('Estable') }, // Option for activated
                                { id: '2', value: _('Inestable') }, // Option for deactivated
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'status',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Label for activation state
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder for selection
                            options: [
                                { id: 'null', value: _('Todos') }, // Option for all
                                { id: '1', value: _('Activa') }, // Option for activated
                                { id: '0', value: _('Inactiva') }, // Option for deactivated
                            ],
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing input fields
                },
            ],
        };

        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Nueva Criptomoneda'), // Button label for adding cryptocurrency
                            hidden: !devConfig.getPermAction('CryptosAdd', 'Add'), // Conditional visibility based on permissions
                            css: 'prm-CryptosAdd',
                            type: 'form',
                            width: screen == 'small' ? 0 : 200, // Conditional width based on screen size
                            click: () => {
                                this.app.callEvent('addCryptos:button', [[]]); // Event call for adding cryptocurrency
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Limpiar'), // Button label for clearing inputs
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                this.getRoot().clear(); // Clear form inputs
                            },
                        },
                        {
                            minWidth: 200,
                            view: 'button',
                            value: _('Consultar'), // Button label for consulting
                            type: 'form',
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('cryptos:filter', [filterdata]); // Event call for filtering cryptocurrencies
                                $$('b1').collapse(); // Collapse the accordion section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true, // Initial state of the accordion
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion section
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Contains upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Main layout of the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide elements based on screen width
                $$('grav2').hide();
                $$('grav3').hide();
            }
        });
    }
}

// FILE DOCUMENTED
